import { Component, Input, Output, EventEmitter, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { PreSubmitIssue } from '../../services/agent.service';

@Component({
  selector: 'app-pre-submit-review',
  templateUrl: './pre-submit-review.component.html',
  styleUrls: ['./pre-submit-review.component.scss'],
  standalone: false
})
export class PreSubmitReviewComponent implements OnChanges, OnDestroy {
  @Input() issues: PreSubmitIssue[] = [];
  @Input() loading = false;
  @Input() visible = false;

  @Output() dismiss = new EventEmitter<void>();
  @Output() submitAnyway = new EventEmitter<void>();
  @Output() recheck = new EventEmitter<void>();
  @Output() autoFix = new EventEmitter<PreSubmitIssue>();
  @Output() navigateToField = new EventEmitter<string>();

  private autoSubmitTimer: any;

  get errorCount(): number {
    return this.issues.filter(i => i.severity === 'error').length;
  }

  get warningCount(): number {
    return this.issues.filter(i => i.severity === 'warning').length;
  }

  get hasErrors(): boolean { return this.errorCount > 0; }
  get hasWarnings(): boolean { return this.warningCount > 0; }
  get canSubmit(): boolean { return !this.loading; }

  get sortedIssues(): PreSubmitIssue[] {
    return [
      ...this.issues.filter(i => i.severity === 'error'),
      ...this.issues.filter(i => i.severity === 'warning')
    ];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loading']) {
      // Always clear any pending timer when loading state changes
      if (this.autoSubmitTimer) {
        clearTimeout(this.autoSubmitTimer);
        this.autoSubmitTimer = null;
      }
      // Only auto-submit when:
      // 1. This is not the initial bind (firstChange) — Angular fires ngOnChanges on first
      //    attach with loading=false/no issues, which would submit the form on page load.
      // 2. The modal is actually visible (user has clicked Submit and the review ran).
      // 3. The review finished loading with no errors or warnings.
      if (!changes['loading'].firstChange && this.visible && !this.loading && !this.hasErrors && !this.hasWarnings) {
        this.autoSubmitTimer = setTimeout(() => this.submitAnyway.emit(), 1500);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.autoSubmitTimer) clearTimeout(this.autoSubmitTimer);
  }

  onIssueClick(issue: PreSubmitIssue): void {
    if (issue.fieldName) {
      this.navigateToField.emit(issue.fieldName);
    }
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('psrm-backdrop')) {
      this.dismiss.emit();
    }
  }
}

